import React from 'react'
import t from 'lib/translations'
import { Product } from './types'
import { getProductName } from './utils'
import FileDelivery from './FileDelivery'
import UrlDelivery from './UrlDelivery'

interface Props {
  product: Product
}

function ProductDelivery({ product }: Props) {
  let assetsLength = product.assetDeliveries?.length || 0
  if (product.assetDeliveryType === 'PhotoAsset') {
    assetsLength = product.assetDeliveries.filter(a => a.masterForGroupId).length
  }

  return (
    <div className="product">
      <div className="product-heading">
        <span>
          <span className="product-name">{getProductName(product)}</span>
          <span className="product-assets-count">
            {assetsLength} av minimum {product.quantity || 1}
          </span>
        </span>
        <span className={`product-state ${product.state}`}>
          {t(`productState.${product.state}`)}
        </span>
      </div>

      <div className="product-assets-delivery">
        {product.assetDeliveryType === 'PhotoAsset' && (
          <FileDelivery product={product} />
        )}

        {product.assetDeliveryType === 'UrlAsset' && (
          <UrlDelivery product={product} />
        )}
      </div>
    </div>
  )
}

export default ProductDelivery
